import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'How do I receive the 6-in-1 system after purchasing?',
  a: 'You will receive immediate access to all 6 components so you can start using them right away — no waiting, no complicated steps.'
}, {
  q: 'What level of hip hop dance instructor is this for?',
  a: "Hip Hop Dance Instructor Ready is designed for instructors at all stages — whether you're teaching your first classes or you've been teaching for years and want a complete, structured system that removes the planning burden entirely."
}, {
  q: 'Does this work for hip hop dance instructors in any country?',
  a: 'Yes. The material is in English and designed to work in any teaching environment, studio, school, or community program worldwide.'
}, {
  q: 'Can I edit the material?',
  a: 'Yes. Every class is structured and ready to use as-is, but you can adapt any session to your group, your time format, or your teaching style.'
}, {
  q: 'What currency will I pay in?',
  a: "You pay in your local currency. The amount adjusts automatically based on the country you're purchasing from."
}, {
  q: "What if it doesn't work for me?",
  a: "You're covered by a full 7-day money-back guarantee. No questions, no complications. Contact us within 7 days for a complete refund."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-cream" data-id="element-78" data-mp="16pihgxwwfulg">
      <div className="max-w-3xl mx-auto" data-id="element-79" data-mp="rzb6f3981dus">
        <div className="text-center mb-16" data-id="element-80" data-mp="s0m9t1yr8jld">
          <h2 className="text-3xl md:text-5xl font-serif font-bold uppercase text-ink" data-id="element-81" data-mp="wy5og2zd6ydu">
            ❓ Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-82" data-mp="iywhzv0ynin2">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-cream-light border border-line rounded-xl overflow-hidden shadow-sm" data-id="element-83" data-mp="2pmdda4jvrgsc" data-mpi={index}>
                <h3 data-id="element-84" data-mp="2kuls69jhu39l">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-burgundy" onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-85" data-mp="2fwtror4s98ts">
                    <span className="font-bold text-lg text-ink pr-8" data-id="element-86" data-mp="2yn1raz99xh58">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`text-burgundy transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-87" data-mp="2ukonige37tb3" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-88" data-mp="3uug85xxh0zon">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-89" data-mp="2q3zqtqr1wp7">
                      <div className="px-6 pb-5 text-ink-soft border-t border-line pt-4" data-id="element-90" data-mp="hhct9dxrw27m">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}